import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

const base = `${API_BASE_URL}/Purchase`;

/** Central cost centers the user can raise/amend indents against */
export const getCentralCostCenterCodes = (uid, rid) =>
    axios.get(`${base}/GetCentralCostCenterCodesNew`, { params: { UID: uid, RID: rid } });

/** Indents open for amendment under a cost center */
export const getAmendIndents = (ccCode) =>
    axios.get(`${base}/GetAmendIndents`, { params: { CCCode: ccCode } });

/** Item category list — legacy passes the selected CC code itself as CType */
export const getIndentCategories = (cType) =>
    axios.get(`${base}/GetIndentcategoriesDetails`, { params: { CType: cType } });

/** 'Exist' / 'NotExist' — whether the indent still has any non-zero item quantity */
export const checkIndentQty = (indentNo, ccCode) =>
    axios.get(`${base}/CheckIndentQty`, { params: { IndentNo: indentNo, CCCode: ccCode } });

/** Current indent items available for amendment */
export const getAmendIndentItems = (ccCode, indentNo) =>
    axios.get(`${base}/GETAmendIndentItems`, { params: { CCCode: ccCode, Indentno: indentNo } });

/** New / Partial PO status for the indent (informational) */
export const checkIndentPOStatus = (indentNo) =>
    axios.get(`${base}/CheckIndentPOStatus`, { params: { IndentNo: indentNo } });

/** Prefix search for adding a new item to the indent — Typ: '1' code, '2' name */
export const autoCompleteIndentItem = (pfx, typ, cat) =>
    axios.get(`${base}/GetAutoComplete`, { params: { Pfx: pfx, Typ: typ, Cat: cat } });

/** Add a brand-new item line to the indent (via the item search box) */
export const savePOIndentItem = ({ itemCode, costCenter, indentNo }) =>
    axios.post(`${base}/SavePOIndentItems`, { ItemCode: itemCode, Costcenter: costCenter, Indentno: indentNo });

/** Remove a newly-added (not-yet-amended) item line from the indent */
export const deleteNewAmendItem = ({ itemcode, indentListId, indentNo }) =>
    axios.post(`${base}/DeleteNewAmendItem`, { itemcode, IndentListId: indentListId, Indentno: indentNo });

/** Submit the indent amendment (or close-indent) for approval */
export const saveIndentItemAmend = (payload) =>
    axios.post(`${base}/SaveIndentItemAmend`, payload);

/** Close an indent whose remaining quantity is entirely zero */
export const cancelIndent = (indentNo, createdBy, roleId) =>
    axios.get(`${base}/CancelIndent`, { params: { IndentNo: indentNo, Createdby: createdBy, Roleid: roleId } });
